import { showHide } from "./showHide";

export const hideElement = (els: string | HTMLElement | NodeListOf<HTMLElement> | HTMLElement[] | null | undefined) => {
  if (!els) return;

  showHide(els, false)

}